<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col cols="12">
            <h4 id="traffic" class="card-title mb-0">Recordatorios Programados</h4>
            <div class="small text-muted">Calendario y listado de recordatorios, con aviso automático por notificación</div>
          </b-col>
        </b-row>
      </b-card>

      <button type="button"
              class="reminders-fab"
              v-b-tooltip.hover.left
              title="Agregar recordatorio"
              @click="add()">
        <b-icon icon="plus" font-scale="1.3"></b-icon>
      </button>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col lg="7" class="mb-3">
            <FullCalendar defaultView="dayGridMonth"
                          height="auto"
                          :plugins="calendarPlugins"
                          :locale="calendarOptions.locale"
                          :weekends="true"
                          :events="calendarEvents"
                          :eventClick="onCalendarEventClick"/>
            <div class="small text-muted mt-2">
              <b-badge class="reminders-legend-pending mr-1">&nbsp;</b-badge> Pendiente
              <b-badge class="reminders-legend-notified ml-2 mr-1">&nbsp;</b-badge> Avisado
              <b-badge class="reminders-legend-completed ml-2 mr-1">&nbsp;</b-badge> Completado
            </div>
          </b-col>

          <b-col lg="5">
            <b-row class="mb-2">
              <b-col>
                <b-form-select v-model="filter.status" size="sm" :options="arr.select.status" @change="load()"></b-form-select>
              </b-col>
            </b-row>

            <b-table class="mb-0"
                  head-variant="dark"
                  :hover="true"
                  :small="true"
                  :items="table.items"
                  :fields="table.fields"
                  :current-page="table.currentPage"
                  :per-page="table.perPage"
                  :tbody-tr-class="rowClass"
                  v-if="table.items.length">

              <template v-slot:cell(remind_at)="data">
                <div class="reminders-list-date">{{ formatDate(data.item.remind_at) }}</div>
                <div class="small text-muted">{{ fromNow(data.item.remind_at) }}</div>
              </template>

              <template v-slot:cell(title)="data">
                <strong>{{ data.item.title }}</strong>
                <b-icon icon="link-45deg"
                        class="reminders-origin-link ml-1"
                        v-if="data.item.origin_url"
                        v-b-tooltip.hover
                        :title="'Ir al origen: ' + (data.item.origin_label || data.item.origin_url)"
                        @click.stop="openOrigin(data.item)"></b-icon>
                <div class="small text-muted" v-if="data.item.description">{{ data.item.description }}</div>
              </template>

              <template v-slot:cell(status)="data">
                <b-badge variant="success" v-if="data.item.completed_at">
                  <b-icon icon="check-circle-fill" class="mr-1"></b-icon>Completado
                </b-badge>
                <b-badge variant="warning" v-else-if="data.item.notified_at">
                  <b-icon icon="bell-fill" class="mr-1"></b-icon>Avisado
                </b-badge>
                <b-badge variant="primary" v-else>
                  <b-icon icon="clock" class="mr-1"></b-icon>Pendiente
                </b-badge>
              </template>

              <template v-slot:cell(actions)="data">
                <div class="d-flex justify-content-center">
                  <b-dropdown size="sm"
                              variant="outline-dark"
                              toggle-class="reminders-actions-toggle"
                              right
                              no-caret>
                    <template v-slot:button-content>
                      <b-icon icon="three-dots-vertical"></b-icon>
                    </template>

                    <b-dropdown-item v-if="!data.item.completed_at" @click="completeItem(data.item)">
                      <b-icon icon="check2" class="mr-2"></b-icon>Completar
                    </b-dropdown-item>
                    <b-dropdown-item v-if="data.item.origin_url" @click="openOrigin(data.item)">
                      <b-icon icon="link-45deg" class="mr-2"></b-icon>Ir al origen
                    </b-dropdown-item>
                    <b-dropdown-item v-if="isOwner(data.item)" @click="edit(data.item)">
                      <b-icon icon="pencil" class="mr-2"></b-icon>Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="duplicateItem(data.item)">
                      <b-icon icon="files" class="mr-2"></b-icon>Duplicar
                    </b-dropdown-item>
                    <b-dropdown-item v-if="isOwner(data.item)" @click="remove(data.item)">
                      <b-icon icon="trash" class="mr-2"></b-icon>Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>

            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron recordatorios</b-alert>

            <nav class="mt-2" v-if="table.items.length > table.perPage">
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="table.items.length"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
            </nav>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-modal v-model="modal.form.active"
               header-bg-variant="dark"
               header-text-variant="white"
               size="lg"
               :key="modal.form._id"
               :id="modal.form._id">
        <div slot="modal-header">
          {{ modal.form.title }}
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Título">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.title"
                            placeholder="Qué tenés que recordar"
                            required>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Descripción">
              <app-textarea size="sm"
                               v-model="crud.form.description"
                               rows="3"
                               placeholder="Detalle opcional">
              </app-textarea>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Fecha / Hora">
              <b-form-input type="datetime-local"
                            size="sm"
                            v-model="crud.form.remind_at"
                            required>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Avisar">
              <b-form-select v-model="crud.form.notify_before_minutes" size="sm" :options="arr.select.notifyBefore"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="ROLES" description="Todo el staff que tenga alguno de estos roles va a recibir el aviso">
              <v-select :options="arr.select.roles" v-model="crud.form.roles_notification" placeholder="Roles" :multiple="true" :select-on-tab="true"></v-select>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="STAFF" description="Si no elegís roles ni staff, el aviso te llega solo a vos">
              <v-select :options="arr.select.staff" v-model="crud.form.staff_notification" placeholder="Staff" :multiple="true" :select-on-tab="true"></v-select>
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="crud.form.origin_label || crud.form.origin_url">
            <div class="small text-muted">
              <b-icon icon="link-45deg"></b-icon>
              Origen: {{ crud.form.origin_label || crud.form.origin_url }}
            </div>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()">Guardar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import moment from 'moment'

  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import esLocale from '@fullcalendar/core/locales/es'
  import interactionPlugin from '@fullcalendar/interaction'

  export default {
    components: {
      FullCalendar,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.RECORDATORIOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudReminders',
          elements: {}
        },
        calendarPlugins: [ dayGridPlugin, interactionPlugin ],
        calendarOptions: {
          locale: esLocale,
        },
        table: {
          items: [],
          fields: [
            {key: 'remind_at', label: 'Cuándo', class: "align-middle"},
            {key: 'title', label: 'Recordatorio', class: "align-middle"},
            {key: 'status', label: 'Estado', class: "align-middle text-center"},
            {key: 'actions', label: '', class: "align-middle text-center"},
          ],
          currentPage: 1,
          perPage: 10,
        },
        filter: {
          status: 'pending',
        },
        arr: {
          select: {
            status: [
              { value: 'pending', text: 'PENDIENTES' },
              { value: 'completed', text: 'COMPLETADOS' },
              { value: '', text: 'TODOS' },
            ],
            notifyBefore: [
              { value: 5, text: '5 minutos antes' },
              { value: 10, text: '10 minutos antes' },
              { value: 15, text: '15 minutos antes' },
              { value: 30, text: '30 minutos antes' },
              { value: 60, text: '1 hora antes' },
              { value: 120, text: '2 horas antes' },
              { value: 1440, text: '1 día antes' },
            ],
            roles: [],
            staff: [],
          }
        },
        modal: {
          form: {
            active: false,
            _id: '',
            title: '',
          }
        },
        crud: {
          form: {
            id: 0,
            title: '',
            description: '',
            remind_at: '',
            notify_before_minutes: 60,
            roles_notification: [],
            staff_notification: [],
            origin_url: '',
            origin_label: '',
          }
        },
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      // Si se llega con un recordatorio puntual (desde un widget o una
      // notificación), se muestran todos para que esté sí o sí en la lista.
      if (this.$route.params.reminderId) {
        this.filter.status = ''
      }

      this.load()
      this.loadRecipientsOptions()

      this._start = true
    },
    activated() {
      if (this._start) {
        this._start = false
        return
      }

      this.load()
      this.loadRecipientsOptions()
    },
    computed: {
      calendarEvents() {
        return this.table.items.map(item => {
          var color = this.eventColor(item)
          return {
            id: item.id,
            title: item.title,
            start: moment(item.remind_at).format('YYYY-MM-DDTHH:mm:ss'),
            color: color,
            textColor: this.eventTextColor(color),
          }
        })
      }
    },
    methods: {
      load() {
        let loader = this.$loading.show()

        serviceAPI.obtenerReminders(this.filter)
          .then((response) => {
            loader.hide()
            this.table.items = response.data
          })
          .catch(error => {
            loader.hide()
            this.$awn.alert(Error.showError(error))
          })
      },
      loadRecipientsOptions() {
        serviceAPI.obtenerRoles().then(response => {
          this.arr.select.roles = response.data.map(role => ({ code: role.id, label: role.name }))
        })
        serviceAPI.obtenerStaff().then(response => {
          this.arr.select.staff = response.data.map(staff => ({ code: staff.id, label: staff.name }))
        })
      },

      getCurrentStaffId() {
        return Session.getSession().auth.user.selector_session
      },
      isOwner(item) {
        return item.staff_id == this.getCurrentStaffId()
      },

      add(prefill = {}) {
        this.crud.form.id = 0
        this.crud.form.title = prefill.title || ''
        this.crud.form.description = prefill.description || ''
        // Default: fecha de hoy, hora actual + 1 hora. Si viene un prefill
        // (ej. duplicar) con remind_at propio, se respeta ese.
        this.crud.form.remind_at = prefill.remind_at || moment().add(1, 'hour').format('YYYY-MM-DDTHH:mm')
        this.crud.form.notify_before_minutes = this.normalizeNotifyBefore(prefill.notify_before_minutes)
        this.crud.form.roles_notification = prefill.roles_notification || []
        this.crud.form.staff_notification = prefill.staff_notification || []
        this.crud.form.origin_url = prefill.origin_url || ''
        this.crud.form.origin_label = prefill.origin_label || ''

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Recordatorio"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.title = item.title
        this.crud.form.description = item.description || ''
        this.crud.form.remind_at = moment(item.remind_at).format('YYYY-MM-DDTHH:mm')
        this.crud.form.notify_before_minutes = this.normalizeNotifyBefore(item.notify_before_minutes)
        this.crud.form.roles_notification = this.hydrateRecipients(item.roles_notification, this.arr.select.roles)
        this.crud.form.staff_notification = this.hydrateRecipients(item.staff_notification, this.arr.select.staff)
        this.crud.form.origin_url = item.origin_url || ''
        this.crud.form.origin_label = item.origin_label || ''

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Recordatorio"
        this.modal.form.active = true
      },
      hydrateRecipients(jsonValue, options) {
        var ids = jsonValue ? JSON.parse(jsonValue) : []
        return ids.map(id => {
          var found = options.find(opt => opt.code == id)
          return found || { code: id, label: '#' + id }
        })
      },
      normalizeNotifyBefore(value) {
        if (value === undefined || value === null || value === '') return 60
        return Math.max(5, Number(value))
      },
      save() {
        if (!this.crud.form.title.trim()) {
          this.$awn.alert("El título es obligatorio")
          return
        }
        if (!this.crud.form.remind_at) {
          this.$awn.alert("La fecha y hora del recordatorio es obligatoria")
          return
        }

        let loader = this.$loading.show()

        var payload = {
          id: this.crud.form.id,
          title: this.crud.form.title,
          description: this.crud.form.description,
          remind_at: this.crud.form.remind_at,
          notify_before_minutes: this.crud.form.notify_before_minutes,
          roles_notification: this.crud.form.roles_notification.map(item => item.code),
          staff_notification: this.crud.form.staff_notification.map(item => item.code),
          origin_url: this.crud.form.origin_url,
          origin_label: this.crud.form.origin_label,
        }

        var result = this.crud.form.id ? serviceAPI.editarReminder(payload) : serviceAPI.agregarReminder(payload)

        result.then(() => {
          loader.hide()
          this.modal.form.active = false
          this.$awn.success("Recordatorio guardado")
          this.load()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },
      remove(item) {
        this.$bvModal.msgBoxConfirm('¿Eliminar el recordatorio "' + item.title + '"?', {
          title: 'Eliminar recordatorio',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'ELIMINAR',
          cancelVariant: 'outline-dark',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            serviceAPI.eliminarReminder(item.id)
              .then(() => {
                this.$awn.success("Recordatorio eliminado")
                this.load()
              })
              .catch(error => {
                this.$awn.alert(Error.showError(error))
              })
          }
        })
      },
      completeItem(item) {
        serviceAPI.completarReminder(item.id)
          .then(() => {
            this.$awn.success("Recordatorio completado")
            this.load()
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error))
          })
      },
      // Sin recurrencia automática: duplicar es la forma simple de "repetir"
      // cuando hace falta. Crea uno nuevo, pendiente, con los mismos datos
      // (menos la fecha, que toma el default de "hoy + 1 hora").
      duplicateItem(item) {
        this.add({
          title: item.title,
          description: item.description,
          notify_before_minutes: item.notify_before_minutes,
          roles_notification: this.hydrateRecipients(item.roles_notification, this.arr.select.roles),
          staff_notification: this.hydrateRecipients(item.staff_notification, this.arr.select.staff),
          origin_url: item.origin_url,
          origin_label: item.origin_label,
        })
      },

      onCalendarEventClick(info) {
        var item = this.table.items.find(i => i.id == info.event.id)
        if (!item) return

        if (this.isOwner(item)) {
          this.edit(item)
        } else if (!item.completed_at) {
          this.completeItem(item)
        }
      },
      openOrigin(item) {
        this.$router.push(item.origin_url)
      },

      eventColor(item) {
        if (item.completed_at) return '#2eb85c'
        if (item.notified_at) return '#f9b115'
        return '#321fdb'
      },
      // FullCalendar solo colorea fondo/borde con "color"; el texto queda
      // fijo por CSS y no siempre contrasta bien. Lo forzamos según el fondo:
      // oscuro (pendiente/completado) -> texto blanco, ámbar (avisado) -> texto oscuro.
      eventTextColor(bgColor) {
        return bgColor == '#f9b115' ? '#2b2b2b' : '#ffffff'
      },
      rowClass(item) {
        if (!item) return ''
        if (this.$route.params.reminderId && item.id == this.$route.params.reminderId) return 'reminders-row-highlight'
        if (item.completed_at) return 'reminders-row-completed'
        return ''
      },
      formatDate(date) {
        return moment(date).format('DD/MM/YYYY HH:mm')
      },
      fromNow(date) {
        return moment(date).fromNow()
      },
    }
  }
</script>
<style>
  .reminders-actions-toggle {
    width: 32px;
    height: 32px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
  .reminders-origin-link {
    cursor: pointer;
    color: #321fdb;
  }
  .reminders-list-date {
    white-space: nowrap;
    font-weight: 600;
  }
  .reminders-row-completed {
    color: #adb5bd;
  }
  .reminders-row-highlight {
    box-shadow: inset 3px 0 0 0 #321fdb;
    background-color: #eef2ff;
  }
  .reminders-legend-pending {
    background-color: #321fdb;
  }
  .reminders-legend-notified {
    background-color: #f9b115;
  }
  .reminders-legend-completed {
    background-color: #2eb85c;
  }
  .reminders-fab {
    position: fixed;
    right: 28px;
    bottom: 28px;
    z-index: 1030;
    width: 56px;
    height: 56px;
    padding: 0;
    border: none;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #4b3cf0, #321fdb);
    color: #fff;
    box-shadow: 0 4px 14px rgba(50, 31, 219, 0.55), 0 2px 6px rgba(50, 31, 219, 0.35);
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
    animation: reminders-fab-pulse 2.4s ease-in-out infinite;
  }
  .reminders-fab:hover {
    background: linear-gradient(135deg, #5c4dff, #3c27f0);
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(50, 31, 219, 0.65), 0 3px 8px rgba(50, 31, 219, 0.4);
  }
  .reminders-fab:active {
    transform: scale(0.95);
  }
  @keyframes reminders-fab-pulse {
    0%, 100% {
      box-shadow: 0 4px 14px rgba(50, 31, 219, 0.55), 0 0 0 0 rgba(50, 31, 219, 0.45);
    }
    50% {
      box-shadow: 0 4px 14px rgba(50, 31, 219, 0.55), 0 0 0 10px rgba(50, 31, 219, 0);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .reminders-fab {
      animation: none;
    }
  }
  @media (max-width: 991.98px) {
    .reminders-fab {
      right: 18px;
      bottom: 18px;
    }
  }
</style>
